import React from "react";
import { Tooltip } from "react-tooltip";
import styles from "./styles/cover-tooltip.module.scss";

type CoverTooltipProps = {
  id: string;
};

const CoverTooltip = ({ id }: CoverTooltipProps) => {
  return <Tooltip className={styles.tooltip} id={id} place="bottom" />;
};

export default CoverTooltip;
